module.exports = __webpack_public_path__ + "static/media/YMCA building.b838b207.jpg";